import React from 'react';
import { G, Path } from 'react-native-svg';

import { IconDef } from './types';

export const Alarm: IconDef = {
  svg: (
    <G>
      <Path
        d="M5 2L2 5M22 5L19 2M6 18L4 20M18 18L20 20M12 8V12L14 14M12 20C14.1217 20 16.1566 19.1571 17.6569 17.6569C19.1571 16.1566 20 14.1217 20 12C20 9.87827 19.1571 7.84344 17.6569 6.34315C16.1566 4.84285 14.1217 4 12 4C9.87827 4 7.84344 4.84285 6.34315 6.34315C4.84285 7.84344 4 9.87827 4 12C4 14.1217 4.84285 16.1566 6.34315 17.6569C7.84344 19.1571 9.87827 20 12 20Z"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </G>
  ),
  svgStyles(color) {
    return {
      stroke: color,
      strokeWidth: 2,
    };
  },
};
